import React, {useCallback, useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input"
import Box from "@material-ui/core/Box";
import {
  useApolloClient,
  useQuery,
} from "/lib/component/util";
import gql from "/vendor/graphql-tag";
import axios from 'axios';
import useRouter from "../util/useRouter";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const openQuery = gql`
  query SwitcherIsOpenQuery {
    modalStack @client
  }
`;

const closeQuery = gql`
  mutation CloseSwitcher {
    clearModal(modal: CREATE_WORKORDER_MODAL) @client
  }
`;

const WINDOW_ID_EVENT_QUERY = gql`
  query FetchWindowIDLog($check: String!, $namespace: String!, $entity: String!) {
    event(check: $check, namespace: $namespace, entity: $entity) {
      id
      check {
        name
        output
      }
    }
  }
`;

export default function CreateOrderDialog() {
  const router = useRouter();
  const pathname = router.location.pathname
  const variables = pathname.split('/').slice(2)
  const namespace = variables[0] ? `LOC: ${variables[0]}` : ''
  const machine = variables[2] ? `${variables[2]}` : ''
  const isProd = window.location.hostname === "onewatch.betmakers.com"
  const url = isProd ? "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/sn_fsm_mobile_work_order_import_set" : "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/workorderdev";

  const { data } = useQuery({query: WINDOW_ID_EVENT_QUERY,
    variables: {
      check: "window-id-log",
      namespace: variables[0],
      entity: variables?.[2] || "0",
    },
    skip: !variables[0] || !variables[2],
  });
  
  const match = data?.event?.check?.output?.match(/:\s+(\d+)/);
  const windowID = `| WindowID: ${match && match[1]}`;

  const email = localStorage.getItem('googleUser') || ''

  const [incident, setIncident] = useState({
    description: '',
    shortDescription:'',
    machine: machine,
    email: email
  });

  useEffect(() => {
    setIncident(prev => ({
      ...prev,
      machine: machine,
      email: email
    }))
  }, [machine, email, windowID, namespace])

  const client = useApolloClient();
  const queryResult = useQuery({ query: openQuery });
  const open = queryResult.data.modalStack.includes("CREATE_WORKORDER_MODAL");

  const handleClose = useCallback(() => {
    client.mutate({ mutation: closeQuery });
  }, [client]);

  const handleInputChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const name = event.target.name;
    const value = event.target.value;

    if (name) {
      setIncident({...incident, [name]: value});
    }
  };

  // const handleCheckboxChange = (event: any) => {
  //   setAssignToMe(event.target.checked);
  // };

  const handleCreate = () => {
    const data = {
      u_short_description: `${incident.shortDescription} ${namespace} ${windowID}`,
      u_description: incident.description,
      u_serial_number: incident.machine,
      u_email: email,
    };
    const headers = isProd ? {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${Buffer.from('Integrationuser:.>4#wnT=(Y=hsMObyX>ojh*q__6cEk:M8N!oF?32').toString('base64')}`,
    } : {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${Buffer.from('integrationuser:y5gvr*ihW)):lSML$B*FtM]lhg^yW8a9c[.[&bqV').toString('base64')}`,
    };

    axios.post(url, data, { headers })
    .then(response => {
      toast.success(`Work Order Submitted - ${response.data.result[0].display_value}`, {
        toastId: response.data.result[0].display_value,
        theme: 'dark',
        autoClose: 5000,
      });
    })
    .catch(error => {
      console.error(error);
      toast.error(`Submission Failed`, {
        toastId: Math.random(),
        theme: 'dark',
        autoClose: 5000,
      });
    });

    handleClose()
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Create Work Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill out the information about the order.
          </DialogContentText>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Subject</InputLabel>
              <Input
                autoFocus
                margin="dense"
                name="shortDescription"
                type="text"
                value={incident.shortDescription}
                onChange={handleInputChange}
              />
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Description of Order</InputLabel>
              <Input
                autoFocus
                margin="dense"
                name="description"
                type="text"
                value={incident.description}
                onChange={handleInputChange}
              />
            </FormControl>
          </Box>
          <Box marginBottom={2}>
            <FormControl fullWidth>
              <InputLabel>Asset</InputLabel>
              <Input
                autoFocus
                margin="dense"
                name="asset"
                type="text"
                value={incident.machine}
                onChange={handleInputChange}
              />
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCreate} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
